/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
export default function MulticastGroupTableConfig($q, $rootScope, $translate, $state, types, utils, userService,
    multicastGroupService, deviceService, networkSettingsService, apiLimitsService, applicationService) {

    var service = {
        getConfig: getConfig
    }

    return service;

    function getConfig(params) {

        var deferred = $q.defer();

        var currentUser = userService.getCurrentUser();
        var authority = currentUser.authority;
        var scope = types.authority[authority].scope;
        var access = types.authority[authority].access;

        if (params.customerId) {
            scope = types.scope.customer;
        }

        if (params.applicationId) {
            applicationService.getApplication(params.applicationId).then(
                (application) => {
                    var tableConfiguration = createMulticastGroupConfig(scope, access, params, application.name);
                    deferred.resolve(tableConfiguration);
                },
                () => {
                    deferred.reject();
                }
            );
        } else {
            var tableConfiguration = createMulticastGroupConfig(scope, access, params);
            deferred.resolve(tableConfiguration);
        }
        return deferred.promise;
    }

    function createMulticastGroupConfig(scope, access, params, entityTitle) {

        var applicationId = params.applicationId;
        var currentUser = userService.getCurrentUser();

        var tableConfiguration = {

            scope: scope,

            entityType: types.entityType.multicast_group,

            tableTitle: getTitle(scope, entityTitle),

            columns: [
                {
                    key: 'createdTime',
                    sortOrder: types.entityTable.sortOrder.desc.value,
                    sortKey: 'CREATED_TIME',
                    title: 'entity.createdTime'
                },
                {
                    key: 'name',
                    sortKey: 'NAME',
                    title: 'multicast-group.name'
                },
                {
                    key: 'deviceEUI',
                    sortKey: 'DEVICE_EUI',
                    title: 'multicast-group.multicast-group-eui'
                },
                {
                    key: 'devAddress',
                    title: 'multicast-group.device-address'
                },
                {
                    key: 'applicationName',
                    sortKey: 'APPLICATION_NAME',
                    title: 'multicast-group.app-name'
                }
            ],

            serverPagedData: true,
            addEntityController: 'AddMulticastGroupController',

            loadEntities: ($scope) => {
                return applicationId
                    ? loadMulticastGroups($scope, applicationId, multicastGroupService.getApplicationMulticastGroups)
                    : scope === types.scope.customer
                        ? loadMulticastGroups($scope, currentUser.customerId, multicastGroupService.getCustomerMulticastGroups)
                        : loadMulticastGroups($scope, currentUser.subCustomerId, multicastGroupService.getSubCustomerMulticastGroups)
            },
            loadEntity: (entityId) => { return loadMulticastGroup(entityId) },
            saveEntity: (entity) => { return saveMulticastGroup(entity) },
            deleteEntity: (entityId) => {
                $rootScope.shouldOverlay = true;
                return multicastGroupService.deleteMulticastGroup(entityId)
                    .then(function () {
                        $rootScope.shouldOverlay = false;
                    })
                    .catch(function () {
                        $rootScope.shouldOverlay = false;
                    })
            },

            addEnabled: () => {
                return access === types.access.admin && applicationId;
            },

            detailsReadOnly: () => {
                return access == types.access.user;
            },
            deleteEnabled: () => {
                return access == types.access.admin;
            },
            entitiesDeleteEnabled: () => {
                return access == types.access.admin;
            },
            deleteEntityTitle: (entity) => {
                return $translate.instant('multicast-group.delete-multicast-group-title', {name: entity.name});
            },
            deleteEntityContent: (/*entity*/) => {
                return $translate.instant('multicast-group.delete-multicast-group-text');
            },
            deleteEntitiesTitle: (count) => {
                return $translate.instant('multicast-group.delete-multicast-groups-title', {count: count}, 'messageformat');
            },
            deleteEntitiesContent: (/*count*/) => {
                return $translate.instant('multicast-group.delete-multicast-groups-text');
            }
        };

        tableConfiguration.actionCellDescriptors = [
            {
                name: 'application.application-details',
                icon: 'apps',
                isEnabled: () => {
                    return true;
                },
                onAction: ($event, entity) => {
                    openApplicationDetails($event, entity.applicationId);
                }
            },
            {
                name: 'multicast-group.manage-devices',
                icon: 'devices_other',
                isEnabled: () => {
                    return true;
                },
                onAction: ($event, entity) => {
                    manageDevices($event, params.subCustomerId, entity);
                }
            }
        ];

        utils.tableConfigDefaults(tableConfiguration);

        return tableConfiguration;
    }

    function loadMulticastGroups($scope, identifierId, multicastGroupLoad) {
        const sort = $scope.vm.query.isFrontEndSort() ? $scope.vm.defaultSortOrder : $scope.vm.query.order;
        var sortDirection = types.entityTable.sortOrder.asc.value;
        var sortField = sort;
        if (sortField[0] === '-') {
            sortDirection = types.entityTable.sortOrder.desc.value;
            sortField = sortField.substring(1);
        }
        return multicastGroupLoad(identifierId, $scope.vm.query.limit, ($scope.vm.query.page - 1), sortField, sortDirection, $scope.vm.query.search)
    }

    function getTitle(scope, entityTitle) {
        var title = $translate.instant('multicast-group.multicast-groups');
        if (entityTitle && entityTitle.length) {
            title = entityTitle + ': ' + title;
        }
        return title;
    }

    function loadMulticastGroup(multicastGroupId) {
        var deferred = $q.defer();
        multicastGroupService.getMulticastGroup(multicastGroupId).then(
            (multicastGroup) => {
                deviceService.getDeviceFCnts(multicastGroupId).then(
                    (fCnts) => {
                        multicastGroup.originFCnts = angular.copy(fCnts);
                        multicastGroup.fCnts = fCnts;
                        networkSettingsService.getMulticastGroupNetworkSettings(types.entityType.device, multicastGroupId).then(
                            (networkSettings) => {
                                multicastGroup.originNetworkSetting = angular.copy(networkSettings);
                                multicastGroup.networkSettings = networkSettings;
                                apiLimitsService.getApiLimits(types.entityType.device, multicastGroupId).then(
                                    (apiLimits) => {
                                        multicastGroup.originApiLimits = angular.copy(apiLimits);
                                        multicastGroup.apiLimits = apiLimits;
                                        deferred.resolve(multicastGroup);
                                    },
                                    () => {
                                        deferred.reject();
                                    }
                                );
                            },
                            () => {
                                deferred.reject();
                            }
                        );
                    },
                    () => {
                        deferred.reject();
                    }
                );
            },
            () => {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function saveMulticastGroup(multicastGroup) {
        var deferred = $q.defer();
        var networkSettings = multicastGroup.networkSettings;
        var apiLimits = multicastGroup.apiLimits;
        var fCnts = multicastGroup.fCnts;

        var originNetworkSettings = multicastGroup.originNetworkSetting;
        var originApiLimits = multicastGroup.originApiLimits;
        var originFCnts = multicastGroup.originFCnts;

        function saveFCnts(multicastGroup) {
            var deferred = $q.defer();
            deviceService.saveDeviceFCnts(multicastGroup.id.id, fCnts).then(
                (fCnts) => {
                    multicastGroup.fCnts = fCnts;
                    multicastGroup.originFCnts = angular.copy(fCnts);
                    deferred.resolve(multicastGroup);
                },
                () => {
                    deferred.reject();
                });
            return deferred.promise;
        }

        function saveApiLimits(multicastGroup) {
            var deferred = $q.defer();
            apiLimitsService.saveApiLimits(apiLimits).then(
                (apiLimits) => {
                    multicastGroup.apiLimits = apiLimits;
                    multicastGroup.originApiLimits = angular.copy(apiLimits);
                    deferred.resolve(multicastGroup);
                },
                () => {
                    deferred.reject();
                }
            );
            return deferred.promise;
        }

        function saveNetworkSettings(multicastGroup) {
            var deferred = $q.defer();
            networkSettingsService.saveMulticastGroupNetworkSettings(networkSettings).then(
                (networkSettings) => {
                    multicastGroup.networkSettings = networkSettings;
                    multicastGroup.originNetworkSetting = angular.copy(networkSettings);
                    deferred.resolve(multicastGroup);
                },
                () => {
                    deferred.reject();
                }
            );
            return deferred.promise;
        }

        var tasks = [];
        tasks.push(multicastGroupService.saveMulticastGroup(multicastGroup));
        if (!angular.equals(originNetworkSettings, networkSettings)) {
            tasks.push(saveNetworkSettings(multicastGroup));
        }
        if (!angular.equals(originApiLimits, apiLimits)) {
            tasks.push(saveApiLimits(multicastGroup));
        }
        if (!angular.equals(originFCnts, fCnts) && deviceService.isAbpEnabled(multicastGroup)) {
            tasks.push(saveFCnts(multicastGroup));
        }

        $q.all(tasks).then(
            (results) => {
                deferred.resolve(results[results.length - 1]);
            },
            () => {
                deferred.reject();
            }
        );

        return deferred.promise;
    }

    function openApplicationDetails($event, applicationId) {
        if ($event) {
            $event.stopPropagation();
        }
        $state.go('home.applications', {entityId: applicationId});
    }

    function manageDevices($event, subCustomerId, multicastGroup) {
        if ($event) {
            $event.stopPropagation();
        }
        if (subCustomerId) {
            $state.go('home.multicastGroups.devices', {subCustomerId: subCustomerId, multicastGroupId: multicastGroup.id.id});
        } else {
            $state.go('home.multicastGroups.devices', {multicastGroupId: multicastGroup.id.id});
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/multicast-group/multicast-group-table.config.js